module.exports = __webpack_public_path__ + "img/support-links.1edf1386.jpg";